const Content = ({ children }) => (
  <main className='px-16--'>{children}</main>
)

export default Content
